import { render, staticRenderFns } from "./WorkflowSelectField.vue?vue&type=template&id=72165cc6&lang=pug&"
import script from "./WorkflowSelectField.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowSelectField.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports